import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import TransitionIcon from '@atlaskit/icon/core/transition';
import Lozenge from '@atlaskit/lozenge';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import {
	type AddNewTransitionRovoPayload,
	type DeleteTransitionRovoPayload,
	type UpdateTransitionRovoPayload,
} from '@atlaskit/rovo-triggers/types';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const statusCategoryToAppearenceMap = {
	UNDEFINED: 'neutral',
	TODO: 'neutral',
	DONE: 'success',
	IN_PROGRESS: 'information',
} as const;

const styles = cssMap({
	transitionIcon: {
		width: '24px',
		height: '24px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.small'),
		flexShrink: 0,
	},
	card: {
		width: '100%',
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderStyle: 'solid',
		borderRadius: token('radius.small'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		backgroundColor: token('elevation.surface.raised'),
	},
});

export const TransitionAction = (
	payload: AddNewTransitionRovoPayload | DeleteTransitionRovoPayload | UpdateTransitionRovoPayload,
): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack space="space.100">
			<Heading size="xsmall">{formatMessage(messages.transitionHeading)}</Heading>
			<Inline xcss={styles.card} space="space.150">
				<Flex xcss={styles.transitionIcon} justifyContent="center" alignItems="center">
					<TransitionIcon label="" />
				</Flex>
				<Flex alignItems="center" wrap="wrap">
					<Flex gap="space.050" wrap="wrap">
						{payload.links.length ? (
							payload.links.map((link) => (
								<Lozenge
									appearance={
										statusCategoryToAppearenceMap[
											link.fromStatusCategory ? link.fromStatusCategory : 'UNDEFINED'
										]
									}
								>
									{link.fromStatusName}
								</Lozenge>
							))
						) : (
							<Text>{formatMessage(messages.anyStatus)}</Text>
						)}
					</Flex>
					<ArrowRightIcon spacing="spacious" label={formatMessage(messages.to)} size="small" />
					<Lozenge
						appearance={
							statusCategoryToAppearenceMap[
								payload.toStatusCategory ? payload.toStatusCategory : 'UNDEFINED'
							]
						}
					>
						{payload.toStatusName}
					</Lozenge>
				</Flex>
			</Inline>
		</Stack>
	);
};
